import AuthService from './auth/auth.service';
import AgreementService from './agreement/agreement.service';
import ErrorService from './error/error.service';
import HttpService from './http.service';
import i18nProvider from './i18n.provider';
import SecuredStorage from './local-storage/secured-storage.service';
import UserStorage from './local-storage/user-storage.service';
import MobileConnectService from './mobile-connect/mobile-connect.service';
import MobileService from './mobile.service';
import NotificationService from './notification/notification.service';
import ListeningPackageService from './package/listeningpackage.service';
import PackageService from './package/package.service';
import PaycellPackageService from './package/paycellpackage.service';
import GlobalSpinnerService from './spinner/global-spinner.service';
import TerritoryProvider from './territory.provider';
import TokenRedirectService from './token-redirect.service';
import UserService from './user/user.service';
import LanguageHttpInterceptor from './language.http-interceptor.service';
import PriceService from './price.service';
import util from './util.service';
import GoogleAnalytics from './analytics/google-analytics.service';
import ConfigService from './config.service';
import FacebookPixelService from './analytics/facebook-analytics.service';
import MixpanelService from './analytics/mixpanel.service';
import StudentPlanService from './package/student.service';
import FamilyPlanService from '../../family-plan/famil-plan.service';

export default angular
  .module('fizyweb.paycell.services', ['pascalprecht.translate'])
  .provider('i18n', i18nProvider)
  .service('errorService', ErrorService)
  .service('mobileService', MobileService)
  .service('httpService', HttpService)
  .service('agreementService', AgreementService)
  .service('globalSpinner', GlobalSpinnerService)
  .service('util', util)
  .service('securedStorage', SecuredStorage)
  .service('userStorage', UserStorage)
  .service('notificationService', NotificationService)
  .service('authService', AuthService)
  .service('userService', UserService)
  .service('packageService', PackageService)
  .service('listeningPackageService', ListeningPackageService)
  .service('paycellPackageService', PaycellPackageService)
  .service('studentPlanService', StudentPlanService)
  .service('tokenRedirectService', TokenRedirectService)
  .service('mobileConnectService', MobileConnectService)
  .service('priceService', PriceService)
  .service('googleAnalytics', GoogleAnalytics)
  .service('facebookAnalytics', FacebookPixelService)
  .service('mixpanelService', MixpanelService)
  .service('configService', ConfigService)
  .service('familyPlanService', FamilyPlanService)
  .factory('languageHttpInterceptor', LanguageHttpInterceptor)
  .provider('territory', TerritoryProvider).name;



// WEBPACK FOOTER //
// src/app/common/services/services.module.ts